import Button from "../../../components/Button";
import Wrapper from "../../../components/Wrapper";
import { useAppSelector } from "../../../hooks/reduxDispatch";
import DataSourceList from "./component/Datasource";
import ChatBotList from "./screens/chatbotList";

const ChatBot = () => {
  const { userProfile } = useAppSelector((s) => s.userProfile);

  return (
    <div>
      <Wrapper>
        <ChatBotList />
      </Wrapper>
    </div>
  );
};

export default ChatBot;
